import React from 'react'
import SearchUI from '../../../widgets/input/SearchUI'
import TextInputSF2 from '../../../widgets/input/TextInputSF2'
import SelectSingleSF from '../../../widgets/input/SelectSingleSF'
import ViewOrUpdate2UI from '../../../widgets/layout/ViewOrUpdate2UI'
import './ActionRight.css'

const ActionRightUI = ({context, messageList,
    statusList, priorityList,
    statusFilter, priorityFilter, onStatusFilterChange, onPriorityFilterChange,
    dueDateDaysFilter, onDueDateDaysFilterChange, searchFilter, onSearchFilterChange,
  }) =>
  <div className='c_tsk_act_r'>
    <ViewOrUpdate2UI messageList={messageList} labelKey='c_due_in_days' editMode={true}>
      <TextInputSF2
        value={dueDateDaysFilter}
        onSubmit={onDueDateDaysFilterChange}
        maxLength={4}
        type='Integer'
      />
    </ViewOrUpdate2UI>
    <ViewOrUpdate2UI messageList={messageList} labelKey='c_status' editMode={true}>
      <SelectSingleSF
        messageList={messageList}
        optionList={statusList}
        onChange={onStatusFilterChange}
        selectedKey={statusFilter}
        removeKey='c_all'
      />
    </ViewOrUpdate2UI>
    <ViewOrUpdate2UI messageList={messageList} labelKey='c_priority' editMode={true}>
      <SelectSingleSF
        messageList={messageList}
        optionList={priorityList}
        onChange={onPriorityFilterChange}
        selectedKey={priorityFilter}
        removeKey='c_all'
      />
    </ViewOrUpdate2UI>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

export default ActionRightUI
